/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, useEffect, useRef, useCallback } from "react";
import DataTable from "../../components/dataTable";
import { getSelectedState, GridColumn as Column } from "@progress/kendo-react-grid";
import { DialogComponent } from "../../components/dialog";
import{ getTenantCookieData, getUserCredential } from "../../lib/cookies";
import { DEFAULT_SORT } from "../../constants/grid";
import { columnMenuProps } from "../../components/customColumnMenu";
import { LoadingPanel } from "../../components/loadingPanel";
import Popup from "../../components/customPopup";
import { FieldWrapper, Form, FormElement } from "@progress/kendo-react-form";
import { Input } from "@progress/kendo-react-inputs";
import { Error, Label } from "@progress/kendo-react-labels";
import { useDispatch } from "react-redux";
import { getter } from "@progress/kendo-react-common";
// import DtuBatchLogs from "../common/dtuBatchLogs";
import { CellRender, RowRender } from "../../components/renderers";
import FeatureModuleService from "./featureModuleService";
import { getfilterDataString, changeCancelBtnState, changeUpdateBtnState } from "../../utils/utils";
import { removeMessage } from "../../redux/actions/setting-actions";
import { HeaderPage } from "../base/headerPage";
import { DELETE_BTN_ACTIONS } from "../../constants/constants";
import { GridButtonFeatureModule } from "./manage-results";
import { Button } from "@progress/kendo-react-buttons";
import UploadDtu from "../user/uploadDtu";

import { Window } from "@progress/kendo-react-dialogs";

const editField = "inEdit";
const SELECTED_FIELD = "selected";
const DATA_ITEM_KEY = "feature_module_mstr_key";
const idGetter = getter(DATA_ITEM_KEY);

const initialSort = [
  {
    field: "user_first_name",
    dir: "asc",
  },
];

const initialFormFields = {
	feature_module_name: "",
	feature_module_desc: "",
}

const cookiesData = getUserCredential();

export const ManageFeatureModules = (restProps) => {
	const [list, Action] = FeatureModuleService();
	const isRulesLibraryFeaturePopup = Boolean(
		restProps.pageProps?.showNameResultPopup || restProps.pageProps?.showRuleResultPopup
	);

	const dispatch = useDispatch();
	const defaultPageSize = getTenantCookieData("record_per_page");
	const [exportData, setExportData] = useState([]);

	const [sort, setSort] = useState(initialSort);
	const [deleteSelectedIds, setDeleteSelectedIds] = useState([]);
	const [errorObj, setErrorObj] = useState({});
	const [confirmationPopup, setConfirmationPopup] = useState({
		title: "Delete",
		desc: "Are you sure you want to delete this record?",
		isVisible: false,
		type: "",
		actionBtn: [],
		data: {},
		action: "Delete",
	});
	const [selectedState, setSelectedState] = useState({});
	const [exportDataClick, setExportDataClick] = useState(false);
	const [selectedRowId, setSelectedRowId] = useState("");
	const [isShow, setShow] = useState({
		deleteSelectedRow: false,
		isFeatureModules: false,
	});
	const [filterData, setFilterData] = useState({
		isSort: false,
		isFilter: false,
		data: "",
		in_sort_number: DEFAULT_SORT.number,
		sort_order: DEFAULT_SORT.order,
	});
	const [pageData, setPage] = useState({
		skip: 0,
		take: defaultPageSize.recordTake,
	})
	const [pageSize, setPageSize] = useState(defaultPageSize);
	const [addNew, setAddNew] = useState(false);
	const [featureModuleAddUpdate, setFeatureModuleAddUpdate] = useState(false);
	const [isAPICall, setAPICall] = useState(false);
	const [dataList, setDataList] = useState([]);
	const [columnsData, setColumnsData] = useState([]);
	const [isCheckColumn, setColumnCheck] = useState(false);
	const [gridColumns, setGridColumns] = useState([]);
	const [formFields, setFormFields] = useState({
		...initialFormFields,
	});
	const [modal, setModal] = useState(true);
	const [stageChange, setStateChange] = useState("DEFAULT");
	const [filterField, setFilterField] = useState({
		logic: "and",
		filters: [],
	});
	const [sortField, setSortField] = useState([]);
	const [gridKey, setGridKey] = useState(0);
	const [hasChanges, setHasChanges] = useState(false);

	const addRef = useRef(null);
	let popupRef = useRef();

	const {
		data,
    columns,
    dataCount,
    setData,
    originalData,
    isAPICalling,
    setAPICallingState,
    initialLoading,
    visible,
    setVisible,
    noDataFound,
    dataState,
    isRefreshLoading,
	} = list;

	const apiCallData = {
		in_filter: null,
		in_sort_number: 1,
		in_sort_order: "DESC",
		in_page_row_offset: 0,
		in_page_rows: defaultPageSize.recordTake,
	}

	if (document.getElementById("grid-result-cancel")) {
		document.getElementById("grid-result-cancel").onclick = function (e) {
			dispatch(
				removeMessage({
					message: "",
					type: "Error",
					show: false,
				})
			);
			originalData.map((item) => {
				item.inEdit = false;
				item.selected = false;
				return 0;
			});
			setData(originalData);
			setErrorObj({});
			setDataList(originalData);

			e.target.disableKendoBtn();

			changeUpdateBtnState("disable", "grid-result-update");
		};
	}

	useEffect(() => {
		if (modal === true) {
			if (featureModuleAddUpdate === false) {
				changeCancelBtnState("disable", "grid-result-cancel");
				changeUpdateBtnState("disable", "grid-result-update");
			}
		}
	}, [modal]);

	useEffect(() => {
		if (featureModuleAddUpdate === false) {
			changeCancelBtnState("disable", "grid-result-cancel");
			changeUpdateBtnState("disable", "grid-result-update");
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [featureModuleAddUpdate, columns]);

	useEffect(() => {
		if (isShow.deleteSelectedRow) {
			remove();
			setShow({ ...restProps.isShow, deleteSelectedRow: false });
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isShow.deleteSelectedRow]);

	useEffect(() => {
		if (list.loadingState.isSaveData) {
			setHasChanges(true);
			setAPICall(true);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [list.loadingState.isSaveData]);

	useEffect(() => {
		if (list.loadingState.isDeleteData) {
			setHasChanges(true);
			list.setLoadState({ ...list.loadingState, isDeleteData: false });
			onRefreshClick();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [list.loadingState.isDeleteData]);

	useEffect(() => {
		setDataList(data);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [data]);

	useEffect(() => {
		if (columns.length > 0) {
			setColumnsData(columns);
			setGridColumns(columns);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [columns]);

	if (document.getElementById("grid-result-update")) {
    document.getElementById("grid-result-update").onclick = function (e) {
      handleUpdate();
    };
  }

	useEffect(() => {
		const dataVal = {
			...apiCallData,
			in_load_type: "grid-reload",
		};
		Action.getFeatureModuleDataList(dataVal);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [restProps.isAPICall]);

	useEffect(() => {
		if (isCheckColumn) {
			setGridColumns(columnsData);
			setColumnCheck(false);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isCheckColumn]);

	useEffect(() => {
		if (isAPICall) {
			setAPICall(false);
			onRefreshClick();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isAPICall]);

	const exitEdit = (dataItem, index, dataIndex, e) => {
		if (!addNew) {
			if (dataItem.feature_module_name === "") {
				handleUpdateValidation();
			}
		}
	}

	const enterEdit = (dataItem, field) => {
		setFeatureModuleAddUpdate(true);

		const newData = data.map((item) => ({
      ...item,
      [editField]: item.feature_module_mstr_key === dataItem.feature_module_mstr_key ? field : undefined,
    }));

    setData(newData);
	}

	const remove = (ids) => {
		setConfirmationPopup({
			...confirmationPopup,
			isVisible: true,
			type: "DELETE_CONFIRM",
			actionBtn: DELETE_BTN_ACTIONS(onCancelConfirm, onDeleteConfirm),
			data: [],
			action: "Delete",
		});
	};

	const onDeleteConfirm = () => {
		const deleteArray = deleteSelectedIds.map((object2) => {
			const object1 = data.find((element) => element.feature_module_mstr_key === object2.id);
			return {
				id: object2.id,
				featureModuleName: object1.feature_module_name,
			};
		});

		let deleteData = {
			in_user_id: cookiesData.out_user_id.toString(),
			in_feature_module_mstr_key: deleteArray,
			in_tenant_id: cookiesData.out_tenant_id,
		};

		Action.deleteFeatureModuleDataAsync(deleteData, apiCallData);

		setConfirmationPopup({
			...confirmationPopup,
			isVisible: false,
			type: "",
			actionBtn: [],
			data: {},
			action: "",
		});
		setSelectedRowId("");
		setSelectedState({});
	}

	const onCancelConfirm = (action) => {
		setConfirmationPopup({
			...confirmationPopup,
			isVisible: false,
			type: "",
			actionBtn: [],
			data: {},
			action: "",
		});

		data.map((item) => {
			item.selected = false;
			return 0;
		})
		setData([...data]);
	}

	const handleValidation = () => {
		let isValid = true;

		if (formFields.feature_module_name.trim() === "") {
			errorObj.feature_module_name = "Please enter feature module name";
			isValid = false;
		} else {
			errorObj.feature_module_name = "";
		}

		setErrorObj((preVState) => ({ ...preVState, errorObj }));
		return isValid;
	}

	const handleUpdateValidation = () => {
		let isValid = true;
		data
		.filter((x) => x.inItemEdit === true)
		.map((item) => {
			const { feature_module_name, rowId } = item;
			let errorObj = {
				feature_module_name: "",
			};

			if (feature_module_name.trim() === "") {
				errorObj.feature_module_name = "Please enter feature module name";
			} else {
				errorObj.feature_module_name = "";
			}

			let obj = {};
			for (const [key, value] of Object.entries(errorObj)) {
				obj[`${key + rowId}`] = `${value}`;
			}

			setErrorObj(obj);
			for (const [, value] of Object.entries(obj)) {
				if (value !== "") {
					isValid = false;
				}
			}

			return 0;
		});
		return isValid;
	};

	const handleUpdate = async () => {
		let valid = handleUpdateValidation();

		if (valid) {
			let updatedDataList = [];
			data
			.filter((x) => x.inItemEdit === true && x.inEdit !== true)
			.map((item) => {
				let obj = {};
				obj.in_user_id = cookiesData.out_user_id.toString();
				obj.in_tenant_id = cookiesData.out_tenant_id;
				obj.in_feature_module_mstr_key = item.feature_module_mstr_key;
				obj.in_feature_module_name = item.feature_module_name;
				obj.in_feature_module_desc = item.feature_module_desc;
				updatedDataList.push(obj);
				return 0;
			});

			const bodyData = {
				updateFeatureModule: [...updatedDataList],
			};

			if (updatedDataList.length > 0) {
				let response = await Action.updateFeatureModuleDataAsync(bodyData);

				if (response) {
					setHasChanges(true);
					onRefreshClick();
					setFeatureModuleAddUpdate(false);
				}
			}
		} else {
			changeCancelBtnState("enable", "grid-result-cancel");
			changeUpdateBtnState("enable", "grid-result-update");
		}
	};

	const handleSubmit = () => {
		let valid = handleValidation();

		if (valid) {
			const bodyData = {
				in_user_id: cookiesData.out_user_id.toString(),
				in_tenant_id: cookiesData.out_tenant_id,
				in_feature_module_name: formFields.feature_module_name,
				in_feature_module_desc: formFields.feature_module_desc,
			};

			Action.addFeatureModuleDataAsync(bodyData);
			onRefreshClick();
			setFeatureModuleAddUpdate(false);
			setSelectedRowId("");
			setAddNew(false);
			setErrorObj({});
			setFormFields(initialFormFields);
		}
	};

	const NameCell = useCallback(
		(props) => {
			const { ariaColumnIndex, columnIndex, dataItem, field, render } = props;
			const isInEdit = (field === dataItem.inEdit);

			let value = props.field + dataItem.rowId;

			const handleChange = (e, props, value) => {
				if (props.onChange) {
					props.onChange({
						dataIndex: 0,
						dataItem: props.dataItem,
						field: props.field,
						syntheticEvent: e.syntheticEvent,
						value: e.target.value,
					});
				}
			};

			const defaultRendering = (
				<td aria-colindex={ariaColumnIndex} data-grid-col-index={columnIndex} title={dataItem[props.field]}>
					{isInEdit ? (
						<Input 
							value={dataItem[props.field]}
							onChange={(e) => {
								handleChange(e, props, value);
							}}
							name={`${props.field}`}
						/>
					) : (
						<span>{props.dataItem[props.field || ""]}</span>
					)}

					{Object.keys(errorObj).length > 0 ? (
						<div role="alert" className="k-form-error k-text-start">
							{Object.keys(errorObj).length > 0 ? errorObj[value] : ""}
						</div>
					) : (
						false
					)}
				</td>
			);
			return render?.call(undefined, defaultRendering, props);
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[errorObj]
	);

	const setPageMenuState = (response) => {
		if (!deleteSelectedIds.length) {
			return false;
		}

		let ids = response.map((el) => el.feature_module_mstr_key);

		let selectedKeys = [];
		let tempArray = [];
		let tempArrayData = [];

		Object.keys(selectedState).map((item) => {
			let obj = {};

			obj.id = Number(item);
			selectedKeys.push(item);
			tempArray.push(obj);

			return 0;
		});

		ids.map((item) => {
			if (selectedKeys && selectedKeys.includes(item.toString())) {
				tempArrayData.push(item);
			}

			return 0;
		});

		let strSelectedKeys = "";

		if (tempArrayData.length > 0) {
			strSelectedKeys = parseInt(selectedKeys[0]);
		}

		setSelectedRowId(strSelectedKeys);
	}

	const getInFilter = () => {
		return filterData.isFilter ? filterData.data : null;
	};

	const getInSortNumber = () => {
		return filterData.isSort ? filterData.in_sort_number : DEFAULT_SORT.number;
	};

	const getInSortOrder = () => {
		return filterData.isSort ? filterData.sort_order : DEFAULT_SORT.order;
	};

	const getPageTake = () => {
		return pageData.take;
	};

	const getPageSkip = () => {
		return pageData.skip;
	};

	const transformFilterValues = (columnMenuData) => {
		return columnMenuData.map((filterItem) => ({
			...filterItem,
			filters: filterItem.filters.map((filter) => ({
				...filter,
				value: typeof filter.value === 'string' 
					? filter.value.replace(/ /g, '_') 
					: filter.value,
			})),
		}));
	};

	const handleColumnMenu = (columnMenuData, isFilter, isSort, filterObj) => {
		if (isSort) {
			setSortField(columnMenuData);
		} else {
			setFilterField(filterObj);
		}

		let index = 1;
		let filterSkip = getPageSkip();
		let filterTake = getPageTake();

		if (isFilter) {
			filterSkip = 0;
			filterTake = pageSize.recordTake;

			// reset pager when filter applies
			setPage({ skip: filterSkip, take: filterTake });
		}

		if (data.length > 0 && columnMenuData[0] !== undefined) {
			let obj = Object.keys(data[0]);
			index = obj.findIndex((x) => x === columnMenuData[0].field) + 1;
		}

		const transformedColumnMenuData = isFilter 
			? transformFilterValues(columnMenuData) 
			: columnMenuData;

		const filterString = isFilter ? getfilterDataString(transformedColumnMenuData, gridColumns) : filterData.data;

		isFilter = false;
		if (filterString !== "") {
			isFilter = true;
		}

		let sortDir = filterData.isSort && columnMenuData.length ? filterData.sort_order : DEFAULT_SORT.order;
		let sortNumber = filterData.isSort && columnMenuData.length ? filterData.in_sort_number : DEFAULT_SORT.number;

		isSort = !columnMenuData.length ? false : filterData.isSort;

		if (columnMenuData[0] !== undefined && columnMenuData[0].dir !== undefined) {
			isSort = true;
			sortDir = columnMenuData[0].dir.toUpperCase();
			sortNumber = index;
		}

		const dataVal = {
			...apiCallData,
			in_filter: isFilter ? filterString : null,
			in_sort_number: sortNumber,
			in_sort_order: sortDir,
			in_page_row_offset: filterSkip,
			in_page_rows: filterTake,
		};

		setFilterData({
			...filterData,
			isFilter: isFilter,
			isSort: isSort,
			data: filterString,
			in_sort_number: sortNumber,
			sort_order: sortDir,
		});

		setAPICallingState(true);

		getGridData(dataVal);
		setFeatureModuleAddUpdate(false);
	};

	const itemChange = useCallback(
		(event) => {
			const field = event.field || "";
			let newData = "";

			newData = data.map((item) => 
				item.feature_module_mstr_key === event.dataItem.feature_module_mstr_key 
					? { ...item, [field]: event.value, inItemEdit: true }
					: item
			);

			setData(newData);
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[data]
	);

	const handlePageChange = async (event) => {
    const pageData = event.page;

    setAPICallingState(true);

    setPage({ skip: pageData.skip, take: pageData.take });

    const dataVal = {
      ...apiCallData,
      in_filter: getInFilter(),
      in_sort_number: getInSortNumber(),
      in_sort_order: getInSortOrder(),
      in_page_row_offset: pageData.skip,
      in_page_rows: pageData.take,
    };

    let response = await Action.getFeatureModuleDataList(dataVal);

    setDataList(response);
    setPageMenuState(response);
    setFeatureModuleAddUpdate(false);
  };

	const getGridData = async (dataVal) => {
    let response = await Action.getFeatureModuleDataList(dataVal);
    setDataList(response);
    setPageMenuState(response);
    setFeatureModuleAddUpdate(false);
    setErrorObj({});

    changeCancelBtnState("disable", "grid-result-cancel");
    changeUpdateBtnState("disable", "grid-result-update");
  };

	const onRefreshClick = () => {
    setAPICallingState(true);

    const dataVal = {
      ...apiCallData,
      in_filter: getInFilter(),
      in_sort_number: getInSortNumber(),
      in_sort_order: getInSortOrder(),
      in_page_row_offset: getPageSkip(),
      in_page_rows: getPageTake(),
    };
    getGridData(dataVal);
    setFeatureModuleAddUpdate(false);
  };

	const handleMenuItemClick = (module) => {
		switch (module) {
			case "export":
				setExportDataClick(true);
				break;
			case "delete": 
				setShow({
					...isShow,
					deleteSelectedRow: !isShow.deleteSelectedRow,
				});
				break;
			default:
				break;
		}
	};

	const useCol = (columns) => {
		return columns.map((column, idx) => {
			return column.show && column.title !== "" ? (
				<Column {...columnMenuProps(column)} field={column.field} key={idx} cell={NameCell} sortable={true} />
			) : (
				false
			);
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	};

	let FeatureModuleColumn = useCol(gridColumns);
	
	const onClosePopup = () => {
		setVisible(!visible);
		restProps.setShow({ ...restProps.visible });
		if (restProps.onClose && hasChanges) {
			restProps.onClose();
		}
	};

	const ModalTitle = () => {
		return <span>Manage Feature Modules</span>;
	};

	const customCellRender = (td, props) => {
		return (
			<CellRender 
				navigatable={true}
				originalProps={props}
				td={td}
				enterEdit={enterEdit}
				editField={editField}
				updateActBtn="grid-result-update"
				cancelActBtn="grid-result-cancel"
			/>
		);
	};

	const customRowRender = (tr, props) => (
    <RowRender originalProps={props} tr={tr} editField={editField} errorObj={errorObj} exitEdit={exitEdit} />
  );

	const setNewSelectedRow = (newState, isReset) => {
		const keys = Object.keys(newState).filter((key) => newState[key] === true);
		setSelectedState(newState);
		let tempArray = [];
		setSelectedRowId(selectedState);
		setSelectedState(newState);

		keys.map((item) => {
			let obj = {};
			obj.id = Number(item);
			tempArray.push(obj);
			return 0;
		});

		setDeleteSelectedIds(tempArray);

		if (isReset) {
			originalData.map((item) => {
				item.inEdit = false;
				item.selected = Number(item.feature_module_mstr_key) === Number(keys[0]);
				return 0;
			});

			const item = originalData.find((it) => it.selected === true);
			if (item) {
				setSelectedRowId(item.feature_module_mstr_key);
			}

			setData(originalData);
			setDataList(originalData);
		} else {
			const item = data.find((it) => it.selected === true);
			if (item) {
				setSelectedRowId(item.feature_module_mstr_key);
			}

			setData(data);
			setDataList(data);
		}
	};

	const onSelectionChange = (event) => {
		const newSelectedState = getSelectedState({
			event,
			selectedState: selectedState,
			dataItemKey: DATA_ITEM_KEY,
		});

		setNewSelectedRow(newSelectedState, false);
	};

	const getExportData = async () => {
    const dataVal = {
      ...apiCallData,
      in_page_row_offset: 0,
      in_page_rows: dataCount,
      in_filter: getInFilter(),
      in_sort_number: getInSortNumber(),
      in_sort_order: getInSortOrder(),
    };

    let res = await Action.exportDataAsync(dataVal);

    if (res) {
      setExportData(res);
    }
  };

	const onClearFilter = async () => {
		setAPICallingState(true);
		setFilterField({ logic: "and", filters: [] });

		const dataVal = {
			...apiCallData,
			in_filter: null,
			in_sort_number: getInSortNumber(),
			in_sort_order: getInSortOrder(),
			in_page_row_offset: getPageSkip(),
			in_page_rows: getPageTake(),
		};

		setFilterData({
			...filterData,
			data: "",
			isFilter: false,
		});

		let response = await Action.getFeatureModuleDataList(dataVal);
		setDataList(response);
		setPageMenuState(response);
	}

	const handleFieldChange = (e) => {
		const name = e.name ? e.name : e.target.name;
		setFormFields({ ...formFields, [name]: e.value });
		setErrorObj({ ...errorObj, [name]: "" });
	};

	const ShowError = useCallback(
		(props) => {
			return <Error>{errorObj[props.name]}</Error>;
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[errorObj]
	);

	const AddNewForm = () => {
    return (
      <Form
        onSubmit={handleSubmit}
        render={() => (
          <FormElement className="emailForm" horizontal={true}>
            <FieldWrapper>
              <div className="k-form-field-wrap-popup">
                <Label>Feature Module Name *: </Label>
                <Input
                  type="text"
                  name="feature_module_name"
                  value={formFields.feature_module_name}
                  onChange={(e) => {
                    handleFieldChange(e);
                  }}
                  autoFocus={true}
                  placeholder="Feature Module Name"
                />
                <ShowError name="feature_module_name" />
              </div>
            </FieldWrapper>
            <FieldWrapper>
              <div className="k-form-field-wrap-popup width170">
                <Label>Feature Module Description : </Label>
                <Input
                  type="text"
                  name="feature_module_desc"
                  value={formFields.feature_module_desc}
                  onChange={(e) => {
                    handleFieldChange(e);
                  }}
                  placeholder="Feature Module Description"
                />
              </div>
            </FieldWrapper>
          </FormElement>
        )}
      />
    );
  };

	const AddNewPopup = () => {
    return (
      <Popup anchor={addRef.current} show={addNew} setShow={setAddNew} className="right0">
        <div className="dot-dropdown-open dot-dropdown-open-Form">
          <div className="caption">
            <span>Add New Feature Module</span>
          </div>

          {AddNewForm()}

          <div className="dropdownFooter">
            <div className="k-form-buttons">
              <Button
                primary={true}
                type="submit"
                onClick={() => {
                  onCancelClick();
                }}
              >
                Cancel
              </Button>
              <Button
                primary={true}
                type="submit"
                onClick={() => {
                  handleSubmit(formFields, errorObj);
                }}
              >
                Save
              </Button>
            </div>
          </div>
        </div>
      </Popup>
    );
  };

	const onCancelClick = () => {
    setFormFields(initialFormFields);
    setErrorObj({});
    setAddNew(false);
  };

	const addNewData = async (e) => {
    setAddNew(!addNew);
    e.preventDefault();
  };

	const AddNewLink = () => {
    return (
      <div ref={popupRef}>
        <a
          className="cta-small"
          onClick={(e) => {
            addNewData(e);
          }}
        >
          <i className="fas fa-plus"></i> Add New Feature Module
        </a>
        {AddNewPopup()}
      </div>
    );
  };

	// TODO: Add upload functionality
	// const handleUpload = (e) => {
  //   setShow({
  //     ...isShow,
  //     dtuUpload: !isShow.dtuUpload,
  //   });
  //   e.preventDefault();
  // };

	const headerConfig = {
		id: "featuremodule",
		buttons: { template_fx: GridButtonFeatureModule },
		add_new_fx: AddNewLink,
		// upload_fx: handleUpload,
		// upload_title: "Feature Module",
		action_menu: {
			delete: { fx: handleMenuItemClick },
		},
		manage_col: {
			columnsData: columnsData,
			setColumnsData: setColumnsData,
			setColumnCheck: setColumnCheck,
		},
	};

	const parent = document.querySelector("#content-" + headerConfig.id);

	if (parent) {
		const deleteRows = parent.querySelector(".delete-rows");

		deleteRows && deleteRows.disableKendoMenu();

		if (selectedRowId !== "") {
			deleteRows && deleteRows.enableKendoMenu();
		}
	}

	const loadingPanel = (
		<div className="k-loading-mask">
			<span className="k-loading-text">Loading</span>
			<div className="k-loading-image"></div>
			<div className="k-loading-color"></div>
		</div>
	);

	const handleStageChange = (e) => {
		setStateChange(e.state);
		if (e.state === "MINIMIZED") {
			setModal(false);
		} else if (e.state === "DEFAULT") {
			setModal(true);
			setTimeout(() => setGridKey((prevKey) => prevKey + 1), 100);
		}
	};

	return (
		<>
			<Window
				className={isRulesLibraryFeaturePopup ? "rules-library-feature-modules-window" : ""}
				title={<ModalTitle />}
				onClose={onClosePopup}
				width={window.innerWidth * 0.6}
				height={window.innerHeight * 0.8}
				resizable={false}
				stage={stageChange}
				onStageChange={handleStageChange}
				modal={modal}
			>
				<div className="dtu-file-container-logs ManageFeatureModules-dialogue"> 
					<div className="content">
						<div className="Quick-links eventtypequicklinks resultstylepopup">
							<HeaderPage pageProps={restProps.pageProps} headerConfig={headerConfig} />
						</div>
					</div>
					{isRefreshLoading && loadingPanel}
					{columns.length > 0 ? (
            <DataTable
              key={gridKey}
              isAPICalling={isAPICalling}
              initialLoading={initialLoading}
              data={data.map((item) => ({
                ...item,
                [SELECTED_FIELD]: selectedState[idGetter(item)],
              }))}
              id="feature-module-grid"
              itemChange={itemChange}
              pageData={pageData}
              dataCount={dataCount}
              sort={sort}
              customColumn={FeatureModuleColumn}
              editField={editField}
              columns={gridColumns}
              setSort={setSort}
              defaultPageSize={defaultPageSize}
              pageSize={pageSize}
              setPageSize={setPageSize}
              setPage={setPage}
              handlePageChange={handlePageChange}
              handleColumnMenu={handleColumnMenu}
              refreshClick={onRefreshClick}
              dataItemKey={DATA_ITEM_KEY}
              setSelectedRowId={setSelectedRowId}
              setExportDataClick={setExportDataClick}
              isExportDataClick={exportDataClick}
              setExportData={setExportDataClick}
              fileName={"Export_Feature_Module.xlsx"}
              cellRender={customCellRender}
              rowRender={customRowRender}
              onSelectionChange={onSelectionChange}
              getExportData={getExportData}
              exportData={exportData}
              dataState={dataState}
              onClearFilter={onClearFilter}
              noDataFound={noDataFound}
              reorderable={false}
              initialFilter={filterField}
              initialSort={sortField}
              stageChange={stageChange}
            />
          ) : initialLoading && data.length === 0 ? (
            false
          ) : (
            <LoadingPanel />
          )}

					<DialogComponent 
						title={confirmationPopup.title}
						onCancelConfirm={onCancelConfirm}
						width={"450"}
						height={"auto"}
						className={"Dialog-Delete"}
						desc={confirmationPopup.desc}
						visible={confirmationPopup.isVisible}
						actionBtn={confirmationPopup.actionBtn}
						titleClassName={confirmationPopup.action === "Delete" ? "delete-confirm" : "unSave-confirm"}
					/>
				</div>
			</Window>
		</>
	)
}